module.exports = __webpack_public_path__ + "static/8WeekProgram-2e2e6f4b3b145eca3930e61cd057d235.png";